import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {WO_WORK_TYPES, WoWorkType} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-wo-hours-tab',
  templateUrl: './wo-hours-tab.component.html',
  standalone: false,
})
export class WoHoursTabComponent implements OnInit, OnChanges {
  @Input() headerId: string | null = null;
  @Input() readonly = false;

  rows: any[] = [];
  isLoaded = false;
  workTypes = WO_WORK_TYPES;
  users: any[] = [];
  userRates: any[] = [];  // all wo_user_billing_rate rows, loaded once

  constructor(
    private woService: WorkOrderService,
    private notification: BsToastService,
    public confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit(): void {
    this.loadRates();
    this.load();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headerId'] && !changes['headerId'].firstChange) {
      this.load();
    }
  }

  loadRates(): void {
    this.woService.getUserBillingRates().subscribe({
      next: (r: any) => {
        this.userRates = r?.Data ?? r?.data ?? r ?? [];
      },
      error: () => {
      }
    });
    this.woService.getUsers().subscribe({
      next: (r: any) => {
        this.users = r?.Data ?? r?.data ?? r ?? [];
      },
      error: () => {
      }
    });
  }

  onUserOrTypeChange(row: any): void {
    if (!row.user_id || !row.work_type) {
      return;
    }
    const match = this.userRates.find(
      (r: any) => r.user_id === row.user_id && r.work_type === row.work_type && r.active !== false
    );
    if (match) {
      row.billing_rate = match.effective_rate ?? match.base_rate ?? null;
    }
  }

  load(): void {
    if (!this.headerId) {
      this.isLoaded = true;
      return;
    }
    this.woService.getWorkOrder(this.headerId).subscribe({
      next: (res: any) => {
        this.rows = (res?.wo_hours ?? []).map((r: any) => ({...r}));
        this.isLoaded = true;
      },
      error: () => {
        this.isLoaded = true;
      }
    });
  }

  addRow(): void {
    this.rows.push({
      id: null,
      header_id: this.headerId,
      user_id: null,
      date: new Date().toISOString().substring(0, 10),
      hours: 0,
      minutes: 0,
      description: '',
      work_type: 'regular' as WoWorkType,
      billing_rate: null,
      billable: true,
      billed_amount: null,
      invoice_detail_id: null,
      sort_order: (this.rows.length + 1) * 10,
    });
  }

  removeRow(index: number): void {
    const row = this.rows[index];
    if (row.invoice_detail_id) {
      this.notification.showWarningToast('This line has been invoiced and cannot be deleted.');
      return;
    }
    this.confirmDialog.confirmThis(
      ['Delete this hours entry?'],
      () => {
        this.rows.splice(index, 1);
      },
      () => {
      }
    );
  }

  save(): void {
    if (!this.headerId) {
      return;
    }
    const body = {wo_header: {}, wo_hours: this.rows};
    console.log('[WO Hours Save] PATCH api/WorkOrder/' + this.headerId, body);
    this.woService.updateWorkOrder(this.headerId, body).subscribe({
      next: () => {
        this.notification.showSuccessToast('Hours saved.');
        this.load();
      },
      error: () => {
        this.notification.showErrorToast('Error saving hours.');
      }
    });
  }

  computedBilled(row: any): number | null {
    if (!row.billable || !row.billing_rate) {
      return null;
    }
    const hrs = (row.hours || 0) + (row.minutes || 0) / 60;
    return Math.round(hrs * row.billing_rate * 100) / 100;
  }

  isPremium(workType: string): boolean {
    return this.workTypes.find(w => w.value === workType)?.isPremium ?? false;
  }
}
